module.exports = __webpack_public_path__ + "img/cta-dosing-bg.bde8795d.png";